import React from "react";
import { GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ensureAncillaryContentDetails } from "../../../../../common/types/ContentDetails";
import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { OnPremAssetDetails } from "../../OnPremAssetDetails";
import { OnPremAncillaryVersionInfo } from "./OnPremAncillaryVersionInfo";

type OnPremAncillaryContentSectionProps = {
    assetDetails: OnPremAssetDetails;
};

export const OnPremAncillaryContentSection: React.FunctionComponent<OnPremAncillaryContentSectionProps> = ({
    assetDetails
}) => {
    ensureAncillaryContentDetails(assetDetails.content);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={assetDetails.content.ancillary.name}
                        maxLength={40}
                        testId="ancillary-name-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[assetDetails.content.subtype]}
                        testId="ancillary-content-type-field"
                    />
                    <LabeledText
                        label="Airline"
                        value={assetDetails.content.airline.name}
                        testId="ancillary-airline-field"
                    />
                </GridColumn>
                <GridColumn sm={6}>
                    <OnPremAncillaryVersionInfo ancillaryId={assetDetails.content.ancillary.id} />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
